import { get } from "../ajax";

export async function summaryData(){
    const url = `/api/DataBoard/GetSummaryData`
    const res = await get(url)
    return res;
}

export async function chartsAndOverview(StartDate:string='',EndDate:string=''){
    const url = `/api/DataBoard/GetOverviewData?StartDate=${StartDate}&EndDate=${EndDate}`
    const res = await get(url)
    return res;
}

export async function cycleInfoList(ActivityId:number){
    const arg = ActivityId?  `?ActivityId=${ActivityId}`:'';
    const url = `/api/DataBoard/GetActivityCycleInfoList${arg}`
    const res = await get(url)
    return res;
}

export async function productAnalysis(ActivityCycleId:number){
    const arg = ActivityCycleId ?  `?ActivityCycleId=${ActivityCycleId}`:'';
    const url = `/api/DataBoard/GetActivityCycleProductList${arg}`
    const res = await get(url)
    return res;
}